'use client'
import * as React from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import invariant from 'tiny-invariant'
import { lazyComponent } from 'utils/lazy-component'
import { tw } from 'utils/classnames'

export const LFS_URL = process.env.NEXT_PUBLIC_LFS_URL
invariant(
  LFS_URL,
  'NEXT_PUBLIC_LFS_URL is required within @repo/animations/download-button-animation',
)

const LazyLottieComponent = lazyComponent(() => import('lottie-react').then(m => m.default))

const url = `${LFS_URL}/web/features/banners/lottie/download-button-animation.json`

export function DownloadButtonAnimation({ className }: { className?: string }) {
  const queryClient = useQueryClient()
  React.useEffect(() => {
    LazyLottieComponent.preload()
    queryClient.prefetchQuery({
      queryKey: ['lottie', 'download-button-animation-data'],
      // oxlint-disable-next-line require-await
      queryFn: async () => fetch(url).then(res => res.json()),
    })
  }, [queryClient])

  const animationQuery = useQuery({
    queryKey: ['lottie', 'download-button-animation-data'],
    // oxlint-disable-next-line require-await
    queryFn: async () => fetch(url).then(res => res.json()),
  })

  if (!animationQuery.data) {
    return null
  }

  return (
    <React.Suspense fallback={<div className={className}>&nbsp;</div>}>
      <LazyLottieComponent.component
        animationData={animationQuery.data}
        loop={true}
        className={tw(
          className,
          '[&_path[fill]]:!fill-current',
          '[&_path[stroke]]:!stroke-current',
        )}
        // Keep this class as a stable renderer hook for tests and debugging.
        rendererSettings={{ className: 'lottie_download_button_animation' }}
      />
    </React.Suspense>
  )
}
